/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  GatewaySessionFacet,
  GatewaySessionFacet$inboundSchema,
} from "./gatewaysessionfacet.js";

export type GatewaySessionFacets = {
  providers: Array<GatewaySessionFacet>;
  servers: Array<GatewaySessionFacet>;
};

/** @internal */
export const GatewaySessionFacets$inboundSchema: z.ZodMiniType<
  GatewaySessionFacets,
  unknown
> = z.object({
  providers: z.array(GatewaySessionFacet$inboundSchema),
  servers: z.array(GatewaySessionFacet$inboundSchema),
});

export function gatewaySessionFacetsFromJSON(
  jsonString: string,
): SafeParseResult<GatewaySessionFacets, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GatewaySessionFacets$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GatewaySessionFacets' from JSON`,
  );
}
